module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "TokenTransferCheck",
    "md5": "e05928f743afface47066dae6e27a185",
    "structs": [
        {
            "name": "LockingScriptParts",
            "params": [
                {
                    "name": "code",
                    "type": "bytes"
                },
                {
                    "name": "data",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "OpPushData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "VarIntData",
            "params": [
                {
                    "name": "len",
                    "type": "int"
                },
                {
                    "name": "value",
                    "type": "int"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxInputProof",
            "params": [
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "txHash",
                    "type": "bytes"
                },
                {
                    "name": "outputIndexBytes",
                    "type": "bytes"
                },
                {
                    "name": "sequenceBytes",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        },
        {
            "name": "TxOutputProof",
            "params": [
                {
                    "name": "txHeader",
                    "type": "bytes"
                },
                {
                    "name": "hashProof",
                    "type": "bytes"
                },
                {
                    "name": "satoshiBytes",
                    "type": "bytes"
                },
                {
                    "name": "scriptHash",
                    "type": "bytes"
                }
            ],
            "genericTypes": []
        }
    ],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "AmountCheckProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TokenProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "Backtrace",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "TxUtil",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "prevouts",
                    "type": "bytes"
                },
                {
                    "name": "tokenScript",
                    "type": "bytes"
                },
                {
                    "name": "tokenTxHeaderArray",
                    "type": "bytes"
                },
                {
                    "name": "tokenTxHashProofArray",
                    "type": "bytes"
                },
                {
                    "name": "tokenSatoshiBytesArray",
                    "type": "bytes"
                },
                {
                    "name": "inputTokenAddressArray",
                    "type": "bytes"
                },
                {
                    "name": "inputTokenAmountArray",
                    "type": "bytes"
                },
                {
                    "name": "tokenOutputSatoshis",
                    "type": "int"
                },
                {
                    "name": "changeSatoshis",
                    "type": "int"
                },
                {
                    "name": "changeAddress",
                    "type": "Ripemd160"
                },
                {
                    "name": "opReturnScript",
                    "type": "bytes"
                }
            ]
        },
        {
            "type": "constructor",
            "params": []
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract/token/tokenTransferCheck.scrypt",
    "hex": "0176018801a901ac515301402097dfd76851bf465e8f715593b217714858bbe9570ff3bd5e33840a34e20ff0262102ba79df5f8ae7604a9830f03c7933028186aede0675a16f025dc4f8be8eec0382201008ce7480da41702918d1ec8e6849ba32b4d65b1e40dc669c31a1e6306b266c5579547985011455930079012493007901149300795893007901149300795193007901149300790128930079529355011493007901149300795493012179aa01237961007901247f75547f77517a7561876901227961007901687f776100005279517f75007f77007901fd87635379537f75517f7761007901007e81517a7561537a75527a527a5379535479937f75537f77527a75517a67007901fe87635379557f75517f7761007901007e81517a7561537a75527a527a5379555479937f75557f77527a75517a67007901ff87635379597f75517f7761007901007e81517a7561537a75527a527a5379595479937f75597f77527a75517a675379517f75007f7761007901007e81517a7561537a75527a527a5379515479937f75517f77527a75517a6868685179517a75517a75517a75517a7561517a7561007982770122798277527952795779940114937f7552795779947f7701247952796151795179011279940124937f755179011179947f77a9517a75517a75618769012379517961517951795a79947f75517a75517a7561537953795879947f7553795779947f775179a98769012479527961517951795b79947f7551795b799451947f77016a8763517951795b799451937f7551795b79947f77014c8767006863517951795b799452937f7551795b799451937f7761007901007e81517a75615a7952949c670068517a75517a756169537953795779947f7553795679947f7761007901007e81517a7561007900a06900790114955479577994517994567951795379937f7551797f77537958955279517994537a75527a527a527975587953795279937f7553797f77597954797f75547954947f7761007901007e81517a75610000527953a169610053799f63012e790051930124957f75000124957f77012d790051930170957f75000170957f77012b790051930114957f75000114957f77012b7900519358957f750058957f7761007901007e81517a75610131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a7561013079567954937f7556797f7761007901007e81517a7561013179577954935279937f75577954937f7757795453799393587a75577a577a577a577a577a577a577a57797501317900519358957f750058957f775379a8577953795379537953795379537953796079615479aa517901207f758769007901207f7761007901007e81517a75615579607f755c7f7761007901007e81517a7561567901707f7501507f775679827752790128959c695679a8517987695479827701209c69557955797e00795879557951930128957f7555790128957f77876951517a75517a75517a75517a75517a75517a75517a75517a75517a7561755e795a79935f7a755e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a7575757575757575757575757568615153799f63012e795151930124957f75510124957f77012d795151930170957f75510170957f77012b795151930114957f75510114957f77012b7951519358957f755158957f7761007901007e81517a75610131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a7561013079567954937f7556797f7761007901007e81517a7561013179577954935279937f75577954937f7757795453799393587a75577a577a577a577a577a577a577a57797501317951519358957f755158957f775379a8577953795379537953795379537953796079615479aa517901207f758769007901207f7761007901007e81517a75615579607f755c7f7761007901007e81517a7561567901707f7501507f775679827752790128959c695679a8517987695479827701209c69557955797e00795879557951930128957f7555790128957f77876951517a75517a75517a75517a75517a75517a75517a75517a75517a7561755e795a79935f7a755e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a7575757575757575757575757568615253799f63012e795251930124957f75520124957f77012d795251930170957f75520170957f77012b795251930114957f75520114957f77012b7952519358957f755258957f7761007901007e81517a75610131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a7561013079567954937f7556797f7761007901007e81517a7561013179577954935279937f75577954937f7757795453799393587a75577a577a577a577a577a577a577a57797501317952519358957f755258957f775379a8577953795379537953795379537953796079615479aa517901207f758769007901207f7761007901007e81517a75615579607f755c7f7761007901007e81517a7561567901707f7501507f775679827752790128959c695679a8517987695479827701209c69557955797e00795879557951930128957f7555790128957f77876951517a75517a75517a75517a75517a75517a75517a75517a75517a7561755e795a79935f7a755e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a5e7a757575757575757575757575756800005a7953a16961005b799f6357790051930114957f75000114957f77567900519358957f750058957f7761007901007e81517a7561007900a0695279517993537a75527a527a0131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a75610079012d7961007958805279610079827700517902fd009f63517951615179517951938000795179827751947f75007f77517a75517a75517a7561517a75675179030000019f6301fd527952615179517951938000795179827751947f75007f77517a75517a75517a75617e517a756751790500000000019f6301fe527954615179517951938000795179827751947f75007f77517a75517a75517a75617e517a75675179090000000000000000019f6301ff527958615179517951938000795179827751947f75007f77517a75517a75517a75617e517a7568686868007953797e517a75517a75517a75617e517a75517a7561557951797e567a75557a557a557a557a557a757575756861515b799f6357795151930114957f75510114957f77567951519358957f755158957f7761007901007e81517a7561007900a0695279517993537a75527a527a0131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a75610079012d7961007958805279610079827700517902fd009f63517951615179517951938000795179827751947f75007f77517a75517a75517a7561517a75675179030000019f6301fd527952615179517951938000795179827751947f75007f77517a75517a75517a75617e517a756751790500000000019f6301fe527954615179517951938000795179827751947f75007f77517a75517a75517a75617e517a75675179090000000000000000019f6301ff527958615179517951938000795179827751947f75007f77517a75517a75517a75617e517a7568686868007953797e517a75517a75517a75617e517a75517a7561557951797e567a75557a557a557a557a557a757575756861525b799f6357795251930114957f75520114957f77567952519358957f755258957f7761007901007e81517a7561007900a0695279517993537a75527a527a0131795f79537953796153795379011e79947f7552797e517958615179517951938000795179827751947f75007f77517a75517a75517a75617e54795479012179947f777e517a75517a75517a75517a75610079012d7961007958805279610079827700517902fd009f63517951615179517951938000795179827751947f75007f77517a75517a75517a7561517a75675179030000019f6301fd527952615179517951938000795179827751947f75007f77517a75517a75517a75617e517a756751790500000000019f6301fe527954615179517951938000795179827751947f75007f77517a75517a75517a75617e517a75675179090000000000000000019f6301ff527958615179517951938000795179827751947f75007f77517a75517a75517a75617e517a7568686868007953797e517a75517a75517a75617e517a75517a7561557951797e567a75557a557a557a557a557a7575757568537951799c69012679827700a063012679527f75007f7702006a87690126790061007958805279610079827700517902fd009f63517951615179517951938000795179827751947f75007f77517a75517a75517a7561517a75675179030000019f6301fd527952615179517951938000795179827751947f75007f77517a75517a75517a75617e517a756751790500000000019f6301fe527954615179517951938000795179827751947f75007f77517a75517a75517a75617e517a75675179090000000000000000019f6301ff527958615179517951938000795179827751947f75007f77517a75517a75517a75617e517a7568686868007953797e517a75517a75517a75617e517a75517a7561527951797e537a75527a527a75680128790128796100527900a0635179610129790128797e01147e51797e0129797e0127797e517a75610079547961007958805279610079827700517902fd009f63517951615179517951938000795179827751947f75007f77517a75517a75517a7561517a75675179030000019f6301fd527952615179517951938000795179827751947f75007f77517a75517a75517a75617e517a756751790500000000019f6301fe527954615179517951938000795179827751947f75007f77517a75517a75517a75617e517a75675179090000000000000000019f6301ff527958615179517951938000795179827751947f75007f77517a75517a75517a75617e517a7568686868007953797e517a75517a75517a75617e517a75517a7561527a75517a75680079517a75517a75517a7561527951797e537a75527a527a5279aa007901347961007982775179517958947f7551790128947f77517a75517a75618769013379011e79615179012379012379210ac407f0e4bd44bfc207355a778b046225a7068fc59ee7eda43ad905aadbffc800206c266b30e6a1319c66dc401e5bd6b432ba49688eecd118297041da8074ce08100125795679615679aa0079610079517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e01007e81517a75615779567956795679567961537956795479577995939521414136d08c5ed2bf3ba048afe6dcaebafeffffffffffffffffffffffffffffff00517951796151795179970079009f63007952799367007968517a75517a75517a7561527a75517a517951795296a0630079527994527a75517a6853798277527982775379012080517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f517f7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e7c7e01205279947f7754537993527993013051797e527e54797e58797e527e53797e52797e57797e0079517a75517a75517a75517a75517a75517a75517a75517a75517a75517a75517a75517a75517a7561ab00795779ac517a75517a75517a75517a75517a75517a75517a75517a75517a7561517a75517a756177777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777777",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp02/contract-desc/tokenTransferCheck.map.json"
}